/**
 * @file: shift多选
 * @author: xiaolong.huang@dmall.com
 * @description: 算法原理: 围绕所有被选中的组件外侧画一个矩形，被这个矩形框起来的组件中，如果存在之前被选中的类型，就
 * 被选中；
 */

import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import * as UIToolkit from '../../UIToolkit/index';
import * as CaptureRule from './captureRule';
import * as SelectToolkit from './toolkit';
import NextTick from '../../utils/nextTick';
import Config from '../../config/index';
import ShortCutKey from '../shortcutkey/index';
import SelectStore from './store/index';
import CodiSystem from '../../codiSystem/index';
import Message from './message';
import { StageEvent } from '../../message/index';

/**
 * 根据事件源和查询规则来获取鼠标点击选中的cube
 */
function shift(ev: Event): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let cubeId: CubeId = CaptureRule.queryCubeIdBeHit($target);
    let selectedCube: CubeNode = CubeTree.findByCubeId(cubeId);

    if (!selectedCube || !SelectToolkit.canSelect(selectedCube)) {
        return;
    }

    // 先把当前点击的cube添加到选择器中
    SelectToolkit.addOne(cubeId);

    // 获取所有已选中的cube类型
    let selectedTypes: Array<CubeType> = SelectStore.allSelectedType();

    // 最新选择边界坐标
    let latestWrapRect: LogicCoordinate = SelectStore.getSelectWrapRect();

    // 把最新的边界矩形坐标传入坐标系统，获取在这个边界内的所有cubeid
    let beContainCubeIds: Array<CubeId> = CodiSystem.getInTargetLogicRectCubeIds(latestWrapRect);

    // 在边界内的cube，筛选出之前已选中的cube类型的cube
    let filterCubeIds: Array<CubeId> = SelectToolkit.filterByTargetTypeCubeIds(selectedTypes, beContainCubeIds);

    // 把筛选出的cube添加到选择器中
    if (filterCubeIds.length >= 60) {
        UIToolkit.showLoading();
        setTimeout(() => {
            SelectToolkit.addGroup(filterCubeIds);
            Message.panelSelectAsync();
            UIToolkit.hideLoading();
        }, 10);
        return;
    }

    SelectToolkit.addGroup(filterCubeIds);
    Message.panelSelectAsync();
}

export {
    shift
}
